"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var QueriesStore_1 = require("stores/QueriesStore");
var PriceQueryStage3_1 = __importDefault(require("./PriceQueryStage3"));
var FleetQueryStage3_1 = __importDefault(require("./FleetQueryStage3"));
var PODQueryStage3_1 = __importDefault(require("./PODQueryStage3"));
var QueryDetailsStage3 = mobx_react_1.observer(function (_a) {
    var data = _a.data;
    return (react_1.default.createElement("div", { className: "query-stage query-stage-3" },
        react_1.default.createElement("div", { className: "title" }, "Stage 3"),
        data.queryType.id === QueriesStore_1.QueryTypes.PRICE &&
            react_1.default.createElement(PriceQueryStage3_1.default, { data: data }),
        data.queryType.id === QueriesStore_1.QueryTypes.FLEET &&
            react_1.default.createElement(FleetQueryStage3_1.default, { data: data }),
        data.queryType.id === QueriesStore_1.QueryTypes.POD &&
            react_1.default.createElement(PODQueryStage3_1.default, { data: data })));
});
exports.default = QueryDetailsStage3;
